import React from 'react';
import './Hero.css';
import heroImage from '../../assets/images/hero/hero-bg.png';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-background"></div>
      <div className="hero-content">
        <div className="hero-text">
          <h1 className="hero-title">Family Park</h1>
          <p className="hero-subtitle">
            — парк культуры и отдыха города Алматы
          </p>
          <Link to="/about">
            <button className="hero-button">
              Подробнее
            </button>
          </Link>
        </div>
        <div className="hero-image">
          <img src={heroImage} alt="Family Park" />
        </div>
      </div>
    </section>
  );
};

export default Hero;